/**
 * @generated SignedSource<<184622e83ad35ea9f738d1042edfe822>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudCostType = "BilledCost" | "EffectiveCost" | "ListCost" | "%future added value";
export type UpdateCostReportingConfigInput = {
  awsCostType?: CloudCostType | null | undefined;
  azureCostType?: CloudCostType | null | undefined;
  gcpCostType?: CloudCostType | null | undefined;
};
export type UpdateCostReportingConfigMutation$variables = {
  input: UpdateCostReportingConfigInput;
};
export type UpdateCostReportingConfigMutation$data = {
  readonly updateCostReportingConfig: {
    readonly costReportingConfig: {
      readonly awsCostType: CloudCostType;
      readonly azureCostType: CloudCostType;
      readonly gcpCostType: CloudCostType;
      readonly id: string;
    };
  };
};
export type UpdateCostReportingConfigMutation = {
  response: UpdateCostReportingConfigMutation$data;
  variables: UpdateCostReportingConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCostReportingConfigPayload",
    "kind": "LinkedField",
    "name": "updateCostReportingConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CostReportingConfig",
        "kind": "LinkedField",
        "name": "costReportingConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "awsCostType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "azureCostType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gcpCostType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCostReportingConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCostReportingConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c335aba16ba06241cdcffb19a970d0c6",
    "id": null,
    "metadata": {},
    "name": "UpdateCostReportingConfigMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCostReportingConfigMutation(\n  $input: UpdateCostReportingConfigInput!\n) {\n  updateCostReportingConfig(input: $input) {\n    costReportingConfig {\n      awsCostType\n      azureCostType\n      gcpCostType\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cca1c10192c4a0d600ec0da41a7f36b9";

export default node;
